import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, gql, compose } from 'react-apollo';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
  Row,
  Col,
  Grid
} from 'react-bootstrap';
import s from './Feedback.css';
import cx from 'classnames';

// Locale
import messages from '../../locale/messages';

// Image icons
import firstImage from '../../../public/SiteImages/360.svg';
import SecondImage from '../../../public/SiteImages/iconsTwo.svg';
import ThriedImage from '../../../public/SiteImages/IconThree.svg';
class Feedback extends React.Component {

  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getFooterSetting: PropTypes.shape({
        title1: PropTypes.string.isRequired,
        title2: PropTypes.string.isRequired,
        title3: PropTypes.string.isRequired,
      })
    }),
  };

  render() {
    // const { data: { loading, getFooterSetting } } = this.props;
      return (
        <div className={s.root}>
            <div className={s.feedbackContainer}>
              <Grid fluid>
                <Row>
                  {
                   <Col
                      xs={12} sm={4} md={4} lg={4} className={cx(s.feedbackBox, 'feedbackBorderLeftRtl')}>
                      <div className={cx(s.feedbackIcon, 'overViewIconrtl')}>
                        <img src={firstImage} />
                      </div>
                      <div className={cx(s.feedbackContent, 'feedbackContent')}>
                        <label className={s.landingLabel}><FormattedMessage {...messages.virtualOfficeToursLabel} /></label>
                      </div>
                    </Col>
                  }
                  {
                    <Col xs={12} sm={4} md={4} lg={4} className={cx(s.feedbackBox, 'feedbackBorderNoneRtl')}>
                      <div className={cx(s.feedbackIcon, 'overViewIconrtl')}>
                        <img src={SecondImage} />
                      </div>
                      <div className={cx(s.feedbackContent, 'feedbackContent')}>
                        <label className={s.landingLabel}><FormattedMessage {...messages.instantCardPaymentLabel} /></label>
                      </div>
                    </Col>
                  }
                  {
                     <Col xs={12} sm={4} md={4} lg={4} className={cx(s.feedbackBox, 'feedbackBorderRightRtl')}>
                      <div className={cx(s.feedbackIcon, 'overViewIconrtl')}>
                        <img src={ThriedImage} />
                      </div>
                      <div className={cx(s.feedbackContent, 'feedbackContent')}>
                        <label className={s.landingLabel}><FormattedMessage {...messages.shortTermRentalsLabel} /></label>
                      </div>
                    </Col>
                  }
                </Row>
              </Grid>
            </div>
        </div>
      );
    
    // Fetch information
    // if (!loading) {
    //   return (
    //     <div className={s.root}>
    //         <div className={s.feedbackContainer}>
    //           <Grid fluid>
    //             <Row>
    //               {
    //                 getFooterSetting && <Col
    //                   xs={12} sm={4} md={4} lg={4} className={cx(s.feedbackBox, 'feedbackBorderLeftRtl')}>
    //                   <div className={cx(s.feedbackIcon, 'overViewIconrtl')}>
    //                     <img src={firstImage} />
    //                   </div>
    //                   <div className={cx(s.feedbackContent, 'feedbackContent')}>
    //                     {/* <label className={s.landingLabel}>{getFooterSetting.title1}</label> */}
    //                     <label className={s.landingLabel}><FormattedMessage {...messages.virtualOfficeToursLabel} /></label>
    //                   </div>
    //                 </Col>
    //               }
    //               {
    //                 getFooterSetting && <Col xs={12} sm={4} md={4} lg={4} className={cx(s.feedbackBox, 'feedbackBorderNoneRtl')}>
    //                   <div className={cx(s.feedbackIcon, 'overViewIconrtl')}>
    //                     <img src={SecondImage} />
    //                   </div>
    //                   <div className={cx(s.feedbackContent, 'feedbackContent')}>
    //                     {/* <label className={s.landingLabel}>{getFooterSetting.title2}</label> */}
    //                     <label className={s.landingLabel}><FormattedMessage {...messages.instantCardPaymentLabel} /></label>
    //                   </div>
    //                 </Col>
    //               }
    //               {
    //                 getFooterSetting && <Col xs={12} sm={4} md={4} lg={4} className={cx(s.feedbackBox, 'feedbackBorderRightRtl')}>
    //                   <div className={cx(s.feedbackIcon, 'overViewIconrtl')}>
    //                     <img src={ThriedImage} />
    //                   </div>
    //                   <div className={cx(s.feedbackContent, 'feedbackContent')}>
    //                     <label className={s.landingLabel}><FormattedMessage {...messages.shortTermRentalsLabel} /></label>
    //                   </div>
    //                 </Col>
    //               }
    //             </Row>
    //           </Grid>
    //         </div>
    //     </div>
    //   );
    // } else {
    //   return <div />
    // }
  }
}

export default compose(
  injectIntl,
  withStyles(s),
//   graphql(gql`
//    query getFooterSetting {
//     getFooterSetting {
//         id
//         title1
//         content1
//         title2
//         content2
//         title3
//         content3
//       }
//     }
// `, { options: { ssr: true } })
)(Feedback);


// WEBPACK FOOTER //
// src/components/Feedback/Feedback.js